"use strict";
exports.__esModule = true;
exports.AuthParams = void 0;
var AuthParams = /** @class */ (function () {
    function AuthParams() {
        this.username = '';
        this.password = '';
        this.companyCode = '';
    }
    return AuthParams;
}());
exports.AuthParams = AuthParams;